import { useEffect } from 'react';
import { motion } from 'framer-motion';
import UniverseSection from '@/components/UniverseSection';
import { TAGLINE_SECONDARY } from '@/data/content';

export default function UniversePage() {
  useEffect(() => {
    document.title = 'THE UNIVERSE — ARC TOONS';
  }, []);

  return (
    <>
      <UniverseSection />
      <section data-testid="universe-city-band" className="relative h-[52vh] overflow-hidden" aria-label="Toon City skyline">
        <motion.img
          src="/assets/arctoons-web-background-opt.webp"
          alt="The skyline of Toon City in the ARC TOONS universe"
          loading="lazy"
          className="absolute inset-0 h-full w-full object-cover"
          initial={{ scale: 1.12 }}
          whileInView={{ scale: 1.02 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 1.6, ease: 'easeOut' }}
        />
        <div
          aria-hidden="true"
          className="absolute inset-0"
          style={{ background: 'linear-gradient(to bottom, #050B18 0%, rgba(5,11,24,0.35) 30%, rgba(5,11,24,0.55) 70%, #050B18 100%)' }}
        />
        <div className="relative z-10 flex h-full flex-col items-center justify-center px-6 text-center">
          <p className="font-mono text-[10px] uppercase tracking-[0.4em] text-electric">TOON CITY — HOME OF THE TOONS</p>
          <p className="mt-4 max-w-3xl font-display text-xl font-extrabold uppercase leading-snug tracking-tight text-snow text-glow-blue sm:text-3xl">
            {TAGLINE_SECONDARY.replace(/•/g, '•')}
          </p>
        </div>
      </section>
    </>
  );
}
